var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import HTTP from "@/http";
import snackbarBus from "@/snackbarBus";
import likesBus from "@/likesBus";
var AudioButtonLike = (function (_super) {
    __extends(AudioButtonLike, _super);
    function AudioButtonLike() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.liked = false;
        return _this;
    }
    AudioButtonLike.prototype.like = function () {
        var _this = this;
        var params = {
            audio_id: this.audio.id,
        };
        HTTP.post("/likes", params)
            .then(function (response) {
            snackbarBus.$emit("show", "Added to Likes");
            _this.liked = true;
            likesBus.$emit("toggled", _this.audio, _this.liked);
        })
            .catch(function (response) {
            snackbarBus.$emit("show", "There was an error. Try again");
        });
    };
    AudioButtonLike.prototype.unlike = function () {
        var _this = this;
        HTTP.delete("/likes", { params: { audio_id: this.audio.id } })
            .then(function (response) {
            snackbarBus.$emit("show", "Removed from Likes");
            _this.liked = false;
            likesBus.$emit("toggled", _this.audio, _this.liked);
        }).catch(function (response) {
            snackbarBus.$emit("show", "There was an error. Try again");
        });
    };
    AudioButtonLike.prototype.toggleLiked = function () {
        this.liked ? this.unlike() : this.like();
    };
    AudioButtonLike.prototype.onLikesChanged = function (likes) {
        var _this = this;
        if (likes) {
            this.liked = likes.find(function (e) { return e.id === _this.audio.id; });
        }
    };
    AudioButtonLike.prototype.created = function () {
        var _this = this;
        this.liked = this.audio.liked;
        likesBus.$on("toggled", function (audio, val) {
            if (audio.id === _this.audio.id) {
                _this.liked = val;
            }
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], AudioButtonLike.prototype, "audio", void 0);
    __decorate([
        Watch("$store.state.user.user.likes", { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AudioButtonLike.prototype, "onLikesChanged", null);
    AudioButtonLike = __decorate([
        Component
    ], AudioButtonLike);
    return AudioButtonLike;
}(Vue));
export default AudioButtonLike;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ButtonLikeAudio.vue
// module id = 213
// module chunks = 0